import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Alert extends PureComponent {
    render() {
        const {
            theme,
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['alert']: true,
            ['alert-' + theme]: true
        });

        return (
            <div className={classNames} {...props} role="alert">
                {children}
            </div>
        );
    }
}

Alert.defaultProps = {
    theme: 'primary'
};

export default Alert;
